import useUserContext from "../../hooks/useUserContext";
import "./mobile-settings.css";
import PaymentsSection from "../../components/paymentsSection/PaymentsSection";
import {LogoutOutlined} from "@ant-design/icons";
import Achievements from "../../components/whatsappBusinessAccount/onBoardingProcess/acheivements/Achievements";
import {Button} from "antd";
import DomainMenu from "../../components/domainMenu/DomainMenu";
import React from "react";

const MobileSettings = () => {
    const { user, actions: { getFirstName, logout } } = useUserContext();
    if(!user) return <div />;
    const firstName = getFirstName();
    return (
        <div className="mobile-settings-container">
            <div className="user-hello">
                <span>Hi {firstName}</span>
                <DomainMenu isOutlined={false} />
            </div>
            <Achievements />
            <PaymentsSection isInitiallyOpen={true}  />
            <Button type="primary" className="danger-button" size="large" onClick={logout}>Logout</Button>
        </div>
    )
}

export default MobileSettings;